import React from 'react'
import classnames from 'classnames'
import { Loading } from '@myxplor/ui'
import { FormButton, FormButtonContent } from '@myxplor/forms'
import { LoadingIcon } from '@myxplor/icons'

import SyncDate from './sync-date'
import './sync-button.css'

const SyncButtonView = ({
  lastSyncedAt,
  loading = false,
  handleSubmit,
  children,
  loadingText = 'Refreshing...',
  compact,
  right,
}) => (
  <div className={
    classnames({
      'syncButton--wrapper': !compact,
      'syncButton--wrapper__compact': compact
    })
  }
  >
    {
      loading ?
        <Loading>
          {loadingText}
        </Loading> :
        <FormButton
          right={right}
          onClick={e => {
            e.preventDefault()

            handleSubmit()
          }}
        >
          <LoadingIcon big={!right} left />
          <FormButtonContent>
            {children || 'Refresh'}
            <SyncDate lastSyncedAt={lastSyncedAt} />
          </FormButtonContent>
        </FormButton>
    }
  </div>
)

export default SyncButtonView 


// WEBPACK FOOTER //
// ./src/ui/sync-button/views/index.jsx